import React from "react";
import { CheckCircleIcon, ClockIcon } from "@heroicons/react/outline";
import Badge from "../../../../components/common/Badge";

const TimelineTab = ({ order, formatDate }) => (
  <div className="space-y-4">
    {order.statusHistory && order.statusHistory.length > 0 ? (
      order.statusHistory.map((history, index) => (
        <div key={history.id || index} className="flex gap-4">
          <div className="flex flex-col items-center">
            <div className="w-8 h-8 rounded-full bg-primary flex items-center justify-center">
              <CheckCircleIcon className="w-5 h-5 text-white" />
            </div>
            {index < order.statusHistory.length - 1 && (
              <div className="w-0.5 h-full bg-gray-300 my-1" />
            )}
          </div>

          <div className="flex-1 pb-6">
            <div className="bg-gray-50 rounded-lg p-4">
              <div className="flex justify-between items-start mb-2">
                <Badge
                  variant={history.status === "CANCELLED" ? "red" : "green"}
                >
                  {history.status}
                </Badge>
                <span className="text-sm text-gray-600">
                  {formatDate(history.timestamp)}
                </span>
              </div>
              {history.comment && (
                <p className="text-sm text-gray-600 mt-2">{history.comment}</p>
              )}
              {history.updatedBy && (
                <p className="text-xs text-gray-500 mt-2">
                  By: {history.updatedBy.name || history.updatedBy.type}
                </p>
              )}
            </div>
          </div>
        </div>
      ))
    ) : (
      <div className="text-center py-8">
        <ClockIcon className="w-12 h-12 text-gray-400 mx-auto mb-3" />
        <p className="text-gray-500">No status history available</p>
      </div>
    )}
  </div>
);

export default TimelineTab;
